import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MUCard from '../ui/MUCard';
import Button from '../ui/Button';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { getProducts } from '../../redux/selectors';
import { docsInfoDynamicContentScreen } from '../../redux/constants/docsInfoContentTypes';
import { history } from '../../App';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BrowserView, MobileView } from 'react-device-detect';
import styles from './style.js';
import './style.css';

function SampleNextArrow(props) {
  const { className, onClick } = props;

  return (
    <div
      className={`${className} ${props.className}`}
      style={{ ...props.style,
        backgroundImage: 'none',
        width: '56px',
        height: '36px'
      }}
      onClick={onClick}
    >
      <img src='/static/images/arrow-right.svg' alt='Next' />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;

  return (
    <div
      className={`${className} ${props.className}`}
      style={{
        ...props.style,
        backgroundImage: 'none',
        width: '56px',
        height: '36px'
      }}
      onClick={onClick}
    >
      <img src='/static/images/arrow-left.svg' alt='Previous' />
    </div >
  );
}

class FeaturedAPIs extends React.Component {
  handleClick = (e, id) => {
    this.props.actions.switchDocsMainContentToInfo();
    this.props.actions.setDocsApiInfo(id, docsInfoDynamicContentScreen, false);
    history.push({
      pathname: '/docs',
      state: { isLinked: true }
    });
  };

  render() {
    const { classes } = this.props;
    const productList = this.props.productsFromStore;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };

    return (
      <>
        <MobileView>
          <div className={classes.sliderAreaDivMobil}>        
            <Grid container spacing={3}>
              {productList.map((item) => (
                 <div key={item.id} className={`w-100 px-3 ${classes.topMarginForSlides}`} onClick={(e) => this.handleClick(e, item.id)}>
                <Grid item xs={12} key={item.id}>
                  <MUCard
                    imageSource={true}
                    imageUrl={item.imageUrl}
                    id={item.id}
                    name={item.name}
                    content={item.summary}
                    media={true}
                    title={true}
                    classes={classes}
                  >
                    <Button
                      text="Find Out More"
                      classes={{
                        root: classes.btnCardAction,
                        text: classes.txtFindMore,
                        label: classes.label
                      }}
                      className={classes.btnCardAction}
                      onClick={(e) => this.handleClick(e, item.id)}
                    />
                  </MUCard>                 
                </Grid>
                </div>
              ))}            
            </Grid>           
          </div>
        </MobileView>
        <BrowserView>
          <div className={classes.sliderAreaDiv}>
            <Slider {...settings}>
              {productList.map((item) => (
                <div key={item.id} className={`w-100 px-3 ${classes.topMarginForSlides}`} onClick={(e) => this.handleClick(e, item.id)}>
                  <MUCard
                    imageSource={true}
                    imageUrl={item.imageUrl}
                    id={item.id}
                    name={item.name}
                    content={item.summary}
                    media={true}
                    title={true}
                    classes={classes}
                  >
                    <Button
                      text="Find Out More"
                      classes={{
                        root: classes.btnCardAction,
                        text: classes.txtFindMore,
                        label: classes.label
                      }}
                      className={classes.btnCardAction}
                      onClick={(e) => this.handleClick(e, item.id)}
                    />
                  </MUCard>
                </div>
              ))}
            </Slider>
          </div> </BrowserView>
        <div className={classes.allAPIs}></div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch)
});

const mapStateToProps = (state) => ({
  productsFromStore: getProducts(state)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(FeaturedAPIs);
